module.exports = __webpack_public_path__ + "static/media/8_Sharyosuisen Japanese Cafe - Tokyo.290816d5.jpg";